import 'css-chunksrc/client/pages/projectPage/resourcesPage/groupsList/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_k10q7_1",
  "button": "_button_k10q7_23"
};